import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { AddPledgeDrawer } from 'assets/js/pages/pledges/AddPledgeDrawer';
import { DuplicatePledgeDrawer } from 'assets/js/pages/pledges/DuplicatePledgeDrawer';
import { PledgeTransactionDrawer } from 'assets/js/pages/pledges/PledgeTransactionDrawer';
import { Pledges } from 'assets/js/pages/pledges/Pledges';
import { ViewPledgeDrawer } from 'assets/js/pages/pledges/ViewPledgeDrawer';
import { DrawerRoute } from 'components/drawer-route';

const PledgesRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute path={`${match.path}/new`} component={AddPledgeDrawer} />
            <DrawerRoute path={`${match.path}/:pledge_id/edit`} component={ViewPledgeDrawer} />
            <DrawerRoute
                path={`${match.path}/:pledge_id/transaction`}
                component={PledgeTransactionDrawer}
            />
            <DrawerRoute
                path={`${match.path}/:pledge_id/duplicate`}
                component={DuplicatePledgeDrawer}
            />
            <Switch>
                <Route component={Pledges} path={`${match.path}`} />
            </Switch>
        </>
    );
};

export { PledgesRouter };
